export default __webpack_public_path__ + "static/media/027-losses.1a3868cc.svg";